/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classnames from "classnames";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./toolbar.scss";

const Toolbar = ({ children }) => {
  const classes = classnames("report-builder__toolbar");
  return (
    <Box paddingLeft="large" paddingRight="large" className={classes}>
      <Box
        className="report-builder__toolbar-inner"
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        {children}
      </Box>
    </Box>
  );
};

export default Toolbar;
